export interface QueryParameters<T> {
  sort?: string;
  limit?: number;
  offset?: number;
  query: T | null;
}
